import React, { useState } from 'react'
import translate from 'react-i18next/dist/commonjs/translate';
import LoginFormContainer from './login-form/LoginFormContainer';
import ResetPasswordFormContainer from './reset-password-form/ResetPasswordFormContainer';
import { Modal, Header } from 'semantic-ui-react';
import { TenantContext } from '../../tenant/TenantContex';
import i18n from "../internationalization/i18n"

const currentFormContstants = {
	LOGIN_FORM: "LOGIN_FORM",
	RESET_PASSWORD_FORM: "RESET_PASWORD_FORM"
};

const LoginComponent = (props) => {

	const [modalOpenState, setModalOpenState] = useState(true);
	const [currentActiveFormState, setCurrentActiveFormState] = useState(currentFormContstants.LOGIN_FORM);

	const close = () => {
		setModalOpenState(false);
		props.history.push(process.env.PUBLIC_URL + "/");
	}

	const onForgotPasswordClick = () => {
		setCurrentActiveFormState(currentFormContstants.RESET_PASSWORD_FORM);
	};

	const onCancelPasswordResetClick = () => {
		setCurrentActiveFormState(currentFormContstants.LOGIN_FORM);
	};

	const getModalProps = () => {
		let modalProps;
		if(props.trigger) {
			modalProps = {
				trigger: props.trigger,
				style: { maxWidth: 450 }
			};
		} else {
			modalProps = {
				open: modalOpenState,
				style: { maxWidth: 450 },
				onClose: close
			};
		}
		return modalProps;
	};

	const isLoginFormActive = () => {
		return currentActiveFormState === currentFormContstants.LOGIN_FORM; 
	};

	const isResetFormActive = () => {
		return currentActiveFormState === currentFormContstants.RESET_PASSWORD_FORM;
	};

	const getContextHeader = () => {
		if(isResetFormActive()) {
			return "resetPasswordTitle";
		}
		return "loginToAccountTitle"
	};

	return (
		<Modal {...getModalProps()} closeIcon>
			<Header icon='sign-in' content={i18n.t(getContextHeader())} />
			<Modal.Content>
				{isLoginFormActive() &&
					<TenantContext.Consumer>
						{tenantContext => (
							<LoginFormContainer md5Hash={tenantContext.md5Hash} loginRest={tenantContext.loginRest} onForgotPasswordClick={onForgotPasswordClick} />
						)}
					</TenantContext.Consumer>
				}
				{isResetFormActive() &&
					<ResetPasswordFormContainer onCancelPasswordResetClick={onCancelPasswordResetClick} />
				}
			</Modal.Content>
		</Modal>);
};


export default translate()(LoginComponent);


// WEBPACK FOOTER //
// ./src/features/common/login/LoginContainer.js